import React, { useContext, useState } from 'react';
import { FaRegHeart } from 'react-icons/fa';
import { Link, useParams } from 'react-router';
import { BASE_URL_API } from '../../References/URLs';
import AuthContext from '../../Store/AuthContext';
import styles from './EachRedemptionProduct.module.css';

const EachRedemptionProduct = (props) => {
    const { product, getCartItems, cartItems, isPointsBased } = props;
    const { storeKey } = useParams();
    const authCtx = useContext(AuthContext);
    const loginData = authCtx?.loginData ? JSON.parse(authCtx.loginData) : null;
    const [isUpdating, setIsUpdating] = useState(false);

    // Check if the product is already in the cart
    const cartItem = cartItems.find((item) => item.productIdentifier === product.productIdentifier);

    // console.log('this is cart item : ', cartItem)

    const updateCart = async (direction) => {
        setIsUpdating(true);
        const updateCartResponse = await fetch(BASE_URL_API + "updateCartRedemption",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    cartItemIdentifier: cartItem.cartItemIdentifier,
                    direction: direction
                }),
            });

        if (!updateCartResponse.ok) {
            console.log("Something went wrong: Server Error");
        } else {
            const updateCartRespo = await updateCartResponse.json();
            if (updateCartRespo.status === "success") {
                getCartItems(); // Refresh cart items
            } else {
                if (updateCartRespo.message === 'token Expired, please login again!') {
                    authCtx.logout()
                } else {
                    console.log(updateCartRespo.message);
                }
            }
        }
        setIsUpdating(false);
    };

    const addToCart = async () => {
        setIsUpdating(true)
        console.log(product)
        const addToCartResponse = await fetch(BASE_URL_API + "addToCartRedemption",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: loginData.userIdentifier,
                    item: product,
                    isPointsBased: isPointsBased
                })
            });

        if (!addToCartResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const addToCartRespo = await addToCartResponse.json()
            if (addToCartRespo.status === "success") {
                getCartItems()
            } else {
                if (addToCartRespo.message === "token Expired, please login again!") {
                    authCtx.logout()
                }
            }
            console.log(addToCartRespo)
        }
        setIsUpdating(false)
    }


    const handleIncrease = () => {
        if (cartItem) {
            updateCart('increase');
        }
    };

    const handleDecrease = () => {
        updateCart('decrease')
    };

    return (
        <div className={styles.card} >
            <div className={styles.wishlistWrapper}>
                <FaRegHeart size={20} color="white" />
            </div>
            <Link to={`/redeem/product/${product?.productIdentifier}?isPointsBased=${isPointsBased}`} className={styles.productThumbnailWrapper}>
                <img src={product?.image_urls || "https://dummyimage.com/sqrpop"} alt={product.productTitle} className={styles.image} />
            </Link>
            <div className={styles.details}>
                <div className={styles.dUpper}>
                    <div className={styles.productName}>{product.productTitle}</div>
                    {isPointsBased === "0" &&
                        <div className={styles.price}>₹{product.offeredPrice}</div>
                    }
                </div>
                {isPointsBased === "1" &&
                    <div className={styles.rewardPointsLine}>
                        <span className={styles.icon}>⭐</span>
                        Buy using {product?.pointsRequired} reward points!
                    </div>

                }
                <div className={styles.addToCartWrapper}>
                    {isUpdating ? (
                        <button className={styles.addToCartButton}>Updating...</button>
                    ) : cartItem ? (
                        <div className={styles.quantityControls}>
                            <button
                                className={styles.decreaseButton}
                                onClick={handleDecrease}
                                disabled={isUpdating}
                            >
                                -
                            </button>
                            <span className={styles.quantity}>{cartItem.quantity}</span>
                            <button
                                className={styles.increaseButton}
                                onClick={handleIncrease}
                                disabled={isUpdating}
                            >
                                +
                            </button>
                        </div>
                    ) : authCtx.isLoggedIn ? (
                        <button
                            className={styles.addToCartButton}
                            onClick={() => addToCart()}
                        >
                            Add to Cart
                        </button>
                    ) : (
                        <Link to={`/login?landingPage=redeem`}>Add To Cart</Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EachRedemptionProduct